import {
    apiUrl
} from '../../config.json';
import axios from 'axios'

const apiEndPoint = apiUrl + "/collections/metadata"
const token = localStorage.getItem('authToken')
axios.interceptors.request.use(
    config => {
        config.headers.authorization = `Bearer ${token}`;
        return config
    },
    error => {
        return Promise.reject(error)
    }
)
export async function fetchCollectionItemInputs(id) {
    let response = await axios.get(apiEndPoint + '/' + id)
    return await response.data
}
export async function fetchSingleCollectionItem(id) {
    const url = apiUrl + "/collections/items/singleItem/" + id;
    let response = await axios.get(url)
    return await response.data
}
export async function deleteCollectionItem(id) {
    const url = apiUrl + "/collections/items/" + id;
    let response = await axios.delete(url)
    return await response.data
}
export async function editCollectionItem(id) {
    const url = apiUrl + "/collections/items/" + id + "/editItem";
    let response = await axios.get(url)
    return await response.data
}

export async function getNumberOfActiveAndInactiveStaffs(id) {
    const url = apiUrl + "/collections/items/" + id + "/numberOfActiveAndInactiveStaffs"
    let response = await axios.get(url)
    return await response.data
}
export async function changeStaffStatus(id) {
    const url = apiUrl + "/collections/items/" + id + "/changeStaffStatus"
    let response = await axios.put(url)
    return await response.data
}

export async function saveCollectionItem(formData, collection) {
    const url = apiUrl + "/collections/items/" + collection;
    const req = await axios({
        method: 'POST',
        url,
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
    return req;
}
export async function updateCollectionItem(formData , id){
    const url = apiUrl + "/collections/items/" + id;
    const req = await axios({
        method: 'POST',
        url,
        data:formData,
        headers:{
            "Content-Type":"multipart/form-data"
        }
    });
    return req
}

export default {
    fetchCollectionItemInputs,
    fetchSingleCollectionItem,
    deleteCollectionItem,
    editCollectionItem,
    getNumberOfActiveAndInactiveStaffs,
    updateCollectionItem,
    changeStaffStatus
}